const getters = {
  baseOption: (state) => {
    var option = {
      "usercode": state.userinfo.usercode,             // 必须字段：用户 id
      "company_id": state.userinfo.company_id,               // 必须字段：企业 id
      "token": state.userinfo.token,                // 必须字段： token
      "seed": state.userinfo.seed,                  // 必须字段： seed
      'userId': state.userinfo.usercode,
      'orgId': state.userinfo.company_id
    }
    return option
  },
  repoList: (state) => {
    var option = {
      "dataList": state.repoList.dataList,
      "roleList": state.repoList.roleList,
      "oldRoleList": state.repoList.oldRoleList,
      "tag": state.repoList.tag,
      "itemId": state.repoList.itemId,
      "showPersonList": state.repoList.showPersonList
    }
    return option
  },
  currentSearch: (state) => {
    return state.search.currentSearch
  },
  listInfo: (state) => {
    return state.search.listInfo
  },
  allField: (state) => {
    return state.search.allField
  }
}

export default getters
